import { createServerFn } from "@tanstack/react-start";
import { providerContactSessions } from "@wags/db/schema";
import { and, eq, inArray } from "drizzle-orm";
import { resolveExistingViewerRef } from "@/lib/core/auth";
import { getDb } from "@/lib/core/db.server";
import { KITS_RECEIVED_SESSION_STATUSES } from "./reach-out/kits-received-statuses";

export const getViewerMessagedKits = createServerFn({ method: "GET" }).handler(
    async () => {
        const ref = await resolveExistingViewerRef();
        if (!ref?.isAuthenticated) return false;
        const db = await getDb();
        const session = await db.query.providerContactSessions.findFirst({
            columns: { id: true },
            where: and(
                eq(providerContactSessions.userId, ref.viewerId),
                inArray(
                    providerContactSessions.status,
                    KITS_RECEIVED_SESSION_STATUSES,
                ),
            ),
        });
        return session !== undefined;
    },
);
